import { getActionType } from './utils';

const initialState = {
  loginMethods: undefined,
  selfData: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateLoginMethods'):
      return {
        ...state,
        loginMethods: action.loginMethods,
      };

    case getActionType('populateSelf'):
      return {
        ...state,
        selfData: action.selfData,
      };

    default:
      return state;
  }
};
